// src/components/Footer.jsx
import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { Phone, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  const { lang } = useLanguage();

  return (
    <footer style={{
      background: "#3b5882",
      color: "var(--color-gray-300)",
      padding: "3rem 0 1.5rem",
      marginTop: "auto"
    }}>
      <div className="container">

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "2rem", marginBottom: "2.5rem" }}>

          {/* Brand */}
          <div>
            <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#fff", marginBottom: "0.75rem" }}>
              نظم<span style={{ color: "var(--color-sky)" }}>.</span>
            </div>
            <p style={{ fontSize: "0.875rem", lineHeight: 1.8, color: "rgb(255, 255, 255)" }}>
              {lang === "ar"
                ? "منصة متخصصة في دعم أسر الأطفال ذوي اضطراب فرط الحركة وتشتت الانتباه"
                : "A specialized platform supporting families of children with ADHD"}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ color: "#fff", marginBottom: "1rem", fontSize: "1rem" }}>
              {lang === "ar" ? "تواصل معنا" : "Contact Us"}
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>

  {[
    { name: "م. جديد عبد الحميد", phone: "0669693767" },
    { name: "م. بوسعيد مليكة", phone: "0658805324" },
    { name: "م. سويد حفصة", phone: "0667182903" },
  ].map((person, i) => (
    <div key={i} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <span style={{ color: "#fff", fontSize: "0.875rem", fontWeight: 600 }}>{person.name}</span>
      <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.78rem" }}>|</span>
      <a
        href={`tel:+213${person.phone.slice(1)}`}
        style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.78rem", direction: "ltr", textDecoration: "none" }}
      >
        {person.phone}
      </a>
    </div>
  ))}

  <div style={{ display: "flex", alignItems: "flex-start", gap: "0.6rem", fontSize: "0.875rem", marginTop: "0.25rem" }}>
    <MapPin size={16} style={{ color: "#fff", flexShrink: 0, marginTop: "0.15rem" }} />
    <span style={{ color: "#fff" }}>{lang === "ar" ? "غرداية، الجزائر" : "Ghardaia, Algeria"}</span>
  </div>

</div>
          </div>

          {/* Social Media */}
          <div>
            <h4 style={{ color: "#fff", marginBottom: "1rem", fontSize: "1rem" }}>
              {lang === "ar" ? "تابعنا" : "Follow Us"}
            </h4>
            <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>

              <SocialBtn
                href="https://wa.me/+213669693767"
                label="WhatsApp"
                color="#25D366"
                icon={
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                }
              />

              <SocialBtn
                href="https://facebook.com"
                label="Facebook"
                color="#1877F2"
                icon={
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                }
              />

              <SocialBtn
                href="https://instagram.com"
                label="Instagram"
                color="#E1306C"
                icon={
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                }
              />

            </div>
          </div>
        </div>

        {/* Google Map */}
        <div style={{ marginBottom: "2rem", borderRadius: "var(--radius-lg)", overflow: "hidden", border: "1px solid var(--color-gray-600)" }}>
          <div style={{ padding: "0.65rem 1rem", background: "var(--color-gray-700)", display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <MapPin size={15} style={{ color: "var(--color-sky)" }} />
            <span style={{ fontSize: "0.85rem", color: "#fff" }}>
              {lang === "ar" ? "موقع العيادة — غرداية، الجزائر" : "Clinic Location — Ghardaia, Algeria"}
            </span>
          </div>
          <iframe
            title="Ghardaia Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d53859.31!2d3.6740!3d32.4902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12f47e6a4b2e3c1f%3A0x8a0b3c4d5e6f7a8b!2sGhardaia%2C%20Algeria!5e0!3m2!1sar!2sdz!4v1234567890"
            width="100%"
            height="220"
            style={{ display: "block", border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Bottom Bar */}
        <div style={{
          paddingTop: "1.25rem",
          borderTop: "1px solid rgba(255,255,255,0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "0.75rem",
          fontSize: "0.8rem",
          color: "#fff"
        }}>
          <span>
            © {new Date().getFullYear()} {lang === "ar" ? "نظم — جميع الحقوق محفوظة" : "Nodom — All rights reserved"}
          </span>
          
          {/* Created By - Creative Hover Design */}
          <CreatedBy lang={lang} />
        </div>

      </div>
    </footer>
  );
}

function SocialBtn({ href, label, color, icon }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label={label}
      style={{
        width: 42, height: 42,
        borderRadius: "var(--radius-md)",
        background: "var(--color-gray-700)",
        border: "1px solid var(--color-gray-600)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: color,
        transition: "all 0.2s",
        textDecoration: "none"
      }}
      onMouseEnter={e => { e.currentTarget.style.background = color; e.currentTarget.style.color = "#fff"; }}
      onMouseLeave={e => { e.currentTarget.style.background = "var(--color-gray-700)"; e.currentTarget.style.color = color; }}
    >
      {icon}
    </a>
  );
}

// 🎯 Creative "Created By" Component with Surprise Hover Effect
function CreatedBy({ lang }) {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <div 
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Main Button - Programming Icon + Name */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        padding: "0.5rem 1rem",
        background: isHovered 
          ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
          : "rgba(255,255,255,0.1)",
        borderRadius: "50px",
        border: "1px solid rgba(255,255,255,0.2)",
        cursor: "pointer",
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        transform: isHovered ? "scale(1.05)" : "scale(1)",
        boxShadow: isHovered 
          ? "0 8px 25px rgba(102, 126, 234, 0.4)"
          : "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        {/* Programming Icon */}
        <div style={{
          width: 24,
          height: 24,
          borderRadius: "6px",
          background: "linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: isHovered ? "0 0 15px rgba(0,210,255,0.6)" : "none",
          transition: "all 0.3s ease"
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="16 18 22 12 16 6"></polyline>
            <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
        </div>
        
        {/* Text */}
        <span style={{
          color: "#fff",
          fontSize: "0.85rem",
          fontWeight: 600,
          letterSpacing: "0.3px"
        }}>
          {lang === "ar" ? "برمجة وتصميم " : "Created by "}
        </span>
        
        <span style={{
          color: "#00d2ff",
          fontSize: "0.85rem",
          fontWeight: 700,
          textShadow: isHovered ? "0 0 10px rgba(0,210,255,0.8)" : "none"
        }}>
          Lacheleg Aymen
        </span>
        
        {/* Animated Arrow */}
        <span style={{
          display: "inline-block",
          transition: "all 0.3s ease",
          transform: isHovered ? "translateX(3px) rotate(-90deg)" : "rotate(-90deg)",
          fontSize: "0.7rem"
        }}>
          ▼
        </span>
      </div>
      
      {/* 🎉 Surprise Popup - Appears on Hover */}
      <div style={{
        position: "absolute",
        bottom: "100%",
        left: "50%",
        transform: isHovered 
          ? "translateX(-50%) translateY(0)" 
          : "translateX(-50%) translateY(10px)",
        opacity: isHovered ? 1 : 0,
        visibility: isHovered ? "visible" : "hidden",
        background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
        borderRadius: "16px",
        padding: "1rem 1.25rem",
        display: "flex",
        gap: "0.75rem",
        boxShadow: "0 15px 40px rgba(0,0,0,0.4), 0 0 30px rgba(102, 126, 234, 0.2)",
        border: "1px solid rgba(255,255,255,0.1)",
        marginBottom: "12px",
        transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
        zIndex: 1000,
        minWidth: "180px",
        justifyContent: "center"
      }}>
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/+213699967264"
          target="_blank"
          rel="noreferrer"
          style={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            background: "linear-gradient(135deg, #25D366 0%, #20b954 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
            transition: "all 0.3s ease",
            animation: isHovered ? "pulse 1.5s infinite" : "none"
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "scale(1.15) rotate(5deg)";
            e.currentTarget.style.boxShadow = "0 8px 25px rgba(37, 211, 102, 0.6)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "scale(1) rotate(0deg)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(37, 211, 102, 0.4)";
          }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </a>
        
        {/* Telegram Button */}
        <a
          href="https://t.me/aymen_lch"
          target="_blank"
          rel="noreferrer"
          style={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            background: "linear-gradient(135deg, #229ED9 0%, #0088cc 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textDecoration: "none",
            boxShadow: "0 4px 15px rgba(34, 158, 217, 0.4)",
            transition: "all 0.3s ease",
            animation: isHovered ? "pulse 1.5s infinite 0.3s" : "none"
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "scale(1.15) rotate(-5deg)";
            e.currentTarget.style.boxShadow = "0 8px 25px rgba(34, 158, 217, 0.6)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "scale(1) rotate(0deg)";
            e.currentTarget.style.boxShadow = "0 4px 15px rgba(34, 158, 217, 0.4)";
          }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.751-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
          </svg>
        </a>
      </div>
      
      {/* CSS Animation Keyframes */}
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}